import styled from 'styled-components';
import { COLOR } from '@latitude/core/utils/constants';
import imgHorizontalRule from './images/horizontal-rule@3x.png';
const HorizontalRule = /*#__PURE__*/styled.div.withConfig({
  displayName: "HorizontalRule",
  componentId: "sc-1y6gsw2-0"
})(["width:100%;height:32px;background:", " url(", ");background-size:auto 24px;background-position:center center;background-repeat:repeat-x;"], COLOR.GREY6, imgHorizontalRule);
export default HorizontalRule;